// src/components/BoardOfEd/components/Program1500.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_1500_CONFIG = {
  fullName: "HEALTH & PHYSICAL EDUCATION",
  docId: "1500",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTeachers",
      label: "Positions – Teachers",
      valueType: "count",
      sources: [{ block: "Positions", key: "Teachers" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Administrative" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTeachers",
      label: "Salaries – Teachers",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Teachers" }],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "lifeGuard",
      label: "Lifeguard",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "LifeGuard" },
        { block: "Purchased Services", key: "Lifeguard" },
        { block: "Salaries", key: "LifeGuard" },
        { block: "Salaries", key: "Lifeguard" }
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "fieldTrips",
      label: "Field Trips",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Field Trips" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "humanGrowthSeminar",
      label: "Human Growth Seminar",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Human Growth Seminar" },
      ],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "resourceSpeakers",
      label: "Resource Speakers",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Resource Speakers" },
      ],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "printing",
      label: "Printing",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Printing" }],
      group: "services",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "instructionalMaterials",
      label: "Instructional Materials",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Instructional Materials" },
        // Occasionally the line is just "Supplies"
        { block: "Supplies / Materials", key: "Supplies" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "technologySoftware",
      label: "Technology – Software",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Technology Software" },
        { block: "Supplies / Materials", key: "Technology - Software" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "duesFees",
      label: "Dues / Fees",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Dues and Fees" },
        { block: "Other", key: "Dues/Fees" },
        { block: "Other", key: "Dues & Fees" },
      ],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "1500 HEALTH & PHYSICAL EDUCATION – Approved",
      sectionKey: "Approved",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "salariesAdmin",
        "salariesTeachers",
        "lifeGuard",
        "fieldTrips",
        "humanGrowthSeminar",
        "resourceSpeakers",
        "printing",
        "instructionalMaterials",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsTeachers: { minWidth: "100px" },

        // Salaries
        salariesAdmin: { minWidth: "120px" },
        salariesTeachers: { minWidth: "110px" },

        // Purchased Services
        lifeGuard: { minWidth: "120px" },
        fieldTrips: { minWidth: "90px" },
        humanGrowthSeminar: { minWidth: "170px" },
        resourceSpeakers: { minWidth: "150px" },
        printing: { minWidth: "90px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "140px" },
        technologySoftware: { minWidth: "150px" },
        duesFees: { minWidth: "110px" },
      },
    },
    {
      id: "actual",
      title: "1500 HEALTH & PHYSICAL EDUCATION – Actual",
      sectionKey: "Actual",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "salariesAdmin",
        "salariesTeachers",
        "lifeGuard",
        "fieldTrips",
        "humanGrowthSeminar",
        "resourceSpeakers",
        "printing",
        "instructionalMaterials",
        "technologySoftware",
        "duesFees",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsTeachers: { minWidth: "100px" },

        // Salaries
        salariesAdmin: { minWidth: "120px" },
        salariesTeachers: { minWidth: "110px" },

        // Purchased Services
        lifeGuard: { minWidth: "120px" },
        fieldTrips: { minWidth: "90px" },
        humanGrowthSeminar: { minWidth: "170px" },
        resourceSpeakers: { minWidth: "150px" },
        printing: { minWidth: "90px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "140px" },
        technologySoftware: { minWidth: "150px" },
        duesFees: { minWidth: "110px" },
      },
    },
  ],

  inflationSumFields: null,
};

export function Program1500(props) {
  return (
    <ProgramBudget programId="1500" config={PROGRAM_1500_CONFIG} {...props} />
  );
}
